import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdSenseAd728 from "../pages/AdSenseAd728";
class Footer extends Component {
  render() {
    return (
      <footer> 
       <section class="padding background-dark">
        <div class="container">
          <div class="row">      
             {AdSenseAd728}      
            <div class="col-sm-8 socialIcon">
                <Link to="https://www.facebook.com/profile.php?id=61575015492712" target="_blank" rel="noopener noreferrer" class="fa fa-facebook facebook"></Link> 
                <Link to="https://www.youtube.com/@ShishirSharma-Developer" target="_blank" rel="noopener noreferrer" className="fa fa-youtube youtube"></Link>
                <Link to="https://www.linkedin.com/company/ittrainingonline" target="_blank" rel="noopener noreferrer" className="fa fa-linkedin linkedin"></Link>
              <div class="clearfix"></div>
              <ul class="list-inline footerLinks">
                  <li class="list-inline-item">
                    <a href="aboutus">About us</a> |
                  </li>
                  <li class="list-inline-item">
                    <a href="contactus">Contact us</a> 
                  </li>
                
              </ul>              
            </div>
            <div class="col-sm-4">
                 <div class="boxHeight"></div>
                 <Link to="#" class="copyRight mt-5">All Rights Reserved ITTrainingonline</Link>
            </div>
          </div>
        </div>
      </section>
    </footer>
    );
  }
}

export default Footer;
